import { useTranslation } from 'react-i18next'
import { HELP_VIDEOS, helpVideoFile, type HelpVideo } from '@ousse/shared'

/**
 * Page publique « Aide en vidéo » (/aide) : les vidéos « Montre-moi » où Cartou montre le site et l'appli.
 * Fichiers publics du site (`/videos/…`), données fictives seulement. Sous-titres proposés, désactivés par défaut :
 * Cartou parle déjà dans une bulle.
 */
export function HelpPage() {
  const { t, i18n } = useTranslation()
  const section = (surface: HelpVideo['surface'], heading: string) => (
    <section aria-labelledby={`help-${surface}`}>
      <h2 id={`help-${surface}`}>{heading}</h2>
      <ul className={`help-videos ${surface}`}>
        {HELP_VIDEOS.filter((v) => v.surface === surface).map((v) => (
          <li key={v.slug} className="card">
            <h3 id={`video-${v.slug}`}>{t(`help.videos.${v.slug}.title`)}</h3>
            <p className="muted">
              {t(`help.videos.${v.slug}.summary`)} · {t('help.duration', { min: Math.floor(v.durationSec / 60), sec: v.durationSec % 60 })}
            </p>
            <video controls preload="none" poster={helpVideoFile(v.slug, 'jpg')} aria-labelledby={`video-${v.slug}`}>
              <source src={helpVideoFile(v.slug, 'mp4')} type="video/mp4" />
              <track kind="subtitles" srcLang="fr" label="Français" src={helpVideoFile(v.slug, 'vtt')} />
            </video>
          </li>
        ))}
      </ul>
    </section>
  )
  return (
    <>
      <h1>{t('help.title')}</h1>
      <p>{t('help.intro')}</p>
      {!i18n.language.startsWith('fr') && <p className="muted">{t('help.frenchOnly')}</p>}
      {section('site', t('help.onSite'))}
      {section('appli', t('help.onApp'))}
    </>
  )
}
